export default{
    setEvents(state,payload){
        state.events = payload;
    },

    setEventPrice(state, payload){
        state.eventPrice = payload;
    }
}